// Defines or overrides the Shopify.formatMoney function if it doesn't exist.
// This function formats a given amount of cents into a currency string based on a specified format.
export function formatMoney(cents, format) {
  if (typeof cents == "string") cents = cents.replace(".", "");
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision = 0, thousands = ".", decimal = ",") {
    if (isNaN(number) || number == null) return 0;
    number = (number / 100.0).toFixed(precision);
    var parts = number.split(".");
    return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands);
  }

  return format.replace(placeholderRegex, (match, key) => {
    switch (key) {
      case "amount":
      case "amount_no_decimals":
      case "amount_with_currency":
      case "amount_no_decimals_with_currency":
      default:
        return formatWithDelimiters(cents, 0);
    }
  });
}